import { render, staticRenderFns } from "./pro-chiose-tab-apps.vue?vue&type=template&id=4d9a35c4";
import script from "./pro-chiose-tab-apps.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tab-apps.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;